import { ConfigApp } from "./app";
import type { ConfigEnvironment } from "./environment";

export type ConfigHeaderApplication = {
  key: ConfigApp;
  display: string;
  uri: string;
};

export const CONFIG_HEADER_APPLICATIONS_BY_ENVIRONMENT: {
  [key in ConfigEnvironment]: ConfigHeaderApplication[];
} = {
  local: [
    {
      key: ConfigApp.admin,
      display: "Admin",
      uri: "http://localhost:3002",
    },
    {
      key: ConfigApp.cms,
      display: "CMS",
      uri: "http://localhost:3001",
    },
  ],
  dev: [
    {
      key: ConfigApp.admin,
      display: "Admin",
      uri: "https://admin-dev.panoscape.app",
    },
    {
      key: ConfigApp.cms,
      display: "CMS",
      uri: "https://cms-dev.panoscape.app",
    },
  ],
  prod: [
    {
      key: ConfigApp.admin,
      display: "Admin",
      uri: "https://admin.panoscape.app",
    },
    {
      key: ConfigApp.cms,
      display: "CMS",
      uri: "https://setup.panoscape.app",
    },
  ],
};
